const selectors = {
  card: '[data-info-card]',
}

class ComponentInfoCards extends HTMLElement {
  #activeCardIndex = null;
  #cards = [];

  constructor() {
    super();

    this.handleCardClick = this.handleCardClick.bind(this);
  }

  handleCardClick(event) {
    event.preventDefault();
    event.stopPropagation();

    
    const card = event.currentTarget;
    const index = parseInt(card.dataset.index ?? 0);
    const position = card.dataset.position ?? 'end';
    const cardCount = this.#cards.length;
    
    if (window.matchMedia('(max-width: 799px)').matches) {
      const newIndex = index === this.#activeCardIndex ? null : index;
      
      this.#activeCardIndex = newIndex;
      this.#cards.forEach((card, index) => {
        card.setAttribute('data-active', index === newIndex ? 'true' : 'false');
      });

      return;
    }

    const isCurrentCard = this.#activeCardIndex === index;

    if (index === cardCount - 1) {
      this.#activeCardIndex = cardCount - 2;
    } else if (index === 0 && position === 'start') {
      this.#activeCardIndex = -1;
    }else if (!isCurrentCard) {
      this.#activeCardIndex = index;
    } else if (isCurrentCard && position === 'end' && index !== cardCount - 1) {
      this.#activeCardIndex = index + 1;
    } else if (isCurrentCard && position === 'start') {
      this.#activeCardIndex = index - 1;
    }

    this.#cards.forEach((card, index) => {
      card.setAttribute('data-position', index > this.#activeCardIndex ? 'end' : 'start');
    });
  }

  connectedCallback() {
    this.#cards = this.querySelectorAll(selectors.card);

    this.#cards.forEach((card, index) => {
      card.addEventListener('click', this.handleCardClick);
    });
  }
}

if (!customElements.get('info-cards')) {
  customElements.define('info-cards', ComponentInfoCards);
}